// extracted by mini-css-extract-plugin
export default {"wrapper":"Suggestion_wrapper__84ck4"};